// extracted by mini-css-extract-plugin
export default {"client":"#3463fe","cohort":"#222","national":"#6d6d6d","defaultTableColor":"#fff"};